var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuSignOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    xmlSpace: "preserve",
    id: "signOut",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "signOut-paths"
  }, /*#__PURE__*/React.createElement("path", {
    id: "signOut-shape",
    stroke: "none",
    fill: "rgb(245, 74, 120)",
    d: "M 17.84,2.02 C 17.84,1.48 18.34,0.99 18.89,1 L 26.51,1 C 27.05,1 27.55,1.49 27.55,2.02 L 27.55,25.1 C 27.55,25.64 27.05,26.12 26.51,26.12 L 18.89,26.12 C 18.34,26.13 17.84,25.64 17.84,25.1 17.84,24.56 18.34,24.08 18.89,24.08 L 25.47,24.08 25.47,3.04 18.89,3.04 C 18.34,3.05 17.83,2.56 17.84,2.02 L 17.84,2.02 Z M 17.84,2.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "signOut-shape2",
    stroke: "none",
    fill: "rgb(245, 74, 120)",
    d: "M 0.5,13.56 C 0.51,13.32 0.61,13.04 0.78,12.86 L 6.33,7.09 C 6.71,6.76 7.43,6.62 7.85,7 8.26,7.38 8.25,8.11 7.84,8.49 L 3.94,12.54 21.65,12.54 C 22.23,12.54 22.69,13 22.69,13.56 22.69,14.12 22.23,14.58 21.65,14.58 L 3.94,14.58 7.84,18.63 C 8.19,18.98 8.26,19.73 7.85,20.12 7.44,20.5 6.69,20.37 6.33,20.03 L 0.78,14.26 C 0.59,14.06 0.5,13.83 0.5,13.56 L 0.5,13.56 Z M 0.5,13.56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSignOut);
export default __webpack_public_path__ + "static/media/menu_sign_out.4920b35d28c7a6222ac111d8f9a886df.svg";
export { ForwardRef as ReactComponent };